
export default {
    state: {
        // appName: "社区治理大数据平台",
        name: {
            // navImg: require("@/assets/favicon.png"),  //珠海
            // navImg: require("@/assets/wjlogo.png"),  //中融
            navImg: require("@/assets/logo.png"),   //平台
            // navImg: require("@/assets/guangdian.png"),   //温江

            // welcome: "欢迎进入智感安防区综合业务3.0管理系统！",   //珠海
            //  welcome:"欢迎进入社区治理大数据平台管理系统!",   //南充
             welcome:"欢迎进入智慧社区综合业务3.0管理系统！",   //平台
             // welcome:"欢迎进入智慧平安小区管理服务平台！",   //温江

            // copyright:"Version 3.0.0 珠海嘉立信发展有限公司 copyright.",  //珠海
            copyright:"Version 3.0.0 成都宏恒信息科技有限公司 copyright.",  //平台
            // copyrights:"四川嘀家网络科技有限公司",  //嘀家科技
            // copyright:"Version 3.0.0 中融安保集团温江分公司 copyright.",  //中融
            // copyright:"Version 3.0.0 中国广电四川网络股份有限公司 copyright.",  //温江

            // loginImg:require("@/assets/logojlx.png"),  //珠海
            // loginImgs:require("@/assets/zhuhai.png"),  //珠海
            loginImg:require("@/assets/logo.png"),      //平台
            // loginImg:require("@/assets/guangdian.png"),      //温江
            // loginImg:require("@/assets/wjlogo.png"),      //中融

            // loginName:"智感安防区综合业务平台", //珠海
            // loginName:"社区治理大数据平台", //南充嘀家科技
            loginName:"智慧社区综合业务平台", //平台
            // loginName:"智慧平安小区管理服务平台", //温江

            //二维码
            code:require("@/assets/erweima.jpg")  //平台

            // code:require("@/assets/wjcode.jpg")  //中融
        },
    },
    getters: {

    },
    mutations: {

    },
    actions: {
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/titleSwitch.js